/**
 * Contractor_Entity type guard.
 *
 * @param {any} contractorJson Contractor object from API
 * @returns {boolean} Return true if type is Contractor_Entity
 */
function validator(
  contractorJson: unknown
): contractorJson is Contractor_Entity {
  if (typeof contractorJson === "object" && contractorJson != null) {
    Contractor_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(contractorJson).includes(element))
        throw new Error("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Contractor_Entity {
  static requiredFields = [
    "id",
    "name",
    "memberID",
    "description",
    "coverURL",
    "contact",
    "phone",
    "email",
    "street",
    "city",
    "state",
    "zipcode",
    "country",
    "trusted",
    "contactBySMS",
    "sourceID",
    "sourceRecordID",
    "createdAt",
    "updatedAt",
  ];

  constructor(contractorJson: unknown) {
    if (validator(contractorJson)) {
      this.id = contractorJson.id;
      this.name = contractorJson.name;
      this.memberID = contractorJson.memberID;
      this.description = contractorJson.description;
      this.coverURL = contractorJson.coverURL;
      this.contact = contractorJson.contact;
      this.phone = contractorJson.phone;
      this.email = contractorJson.email;
      this.street = contractorJson.street;
      this.city = contractorJson.city;
      this.state = contractorJson.state;
      this.zipcode = contractorJson.zipcode;
      this.country = contractorJson.country;
      this.trusted = contractorJson.trusted;
      this.contactBySMS = contractorJson.contactBySMS;
      this.sourceID = contractorJson.sourceID;
      this.sourceRecordID = contractorJson.sourceRecordID;
      this.organizationID = contractorJson.organizationID;
      this.color = contractorJson.color;
      this.createdAt = contractorJson.createdAt;
      this.updatedAt = contractorJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Contractor_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  name: string;
  memberID: number;
  description: string;
  coverURL: string;
  contact: string;
  phone: string;
  email: string;
  street: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  color?: string;
  trusted: boolean;
  contactBySMS: boolean;
  sourceID: number;
  sourceRecordID: number;
  /**
   * The Rhapsody organization behind a mirrored contractor (unset for
   * member-owned records); joins the contractor to its custom fields.
   */
  organizationID?: number;
  createdAt: string;
  updatedAt: string;
}
